/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Inbox_S2Inputs */

const en_tut_inbox_s2 = /** @type {(inputs: Tut_Inbox_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It holds mentions, thread replies, issues assigned to you, approvals waiting on you, Digital Deputy actions, and your **While you were away** briefings.`)
};

const id_tut_inbox_s2 = /** @type {(inputs: Tut_Inbox_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isinya: mention, balasan thread, issue yang ditugaskan ke Anda, approval yang menunggu, tindakan Wakil Digital, dan ringkasan **Selagi Anda pergi**.`)
};

/**
* | output |
* | --- |
* | "It holds mentions, thread replies, issues assigned to you, approvals waiting on you, Digital Deputy actions, and your **While you were away** briefings." |
*
* @param {Tut_Inbox_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_inbox_s2 = /** @type {((inputs?: Tut_Inbox_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Inbox_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_inbox_s2(inputs)
	return en_tut_inbox_s2(inputs)
});